import { type Ref } from "react";

import ChevronLeftIcon from "@repo/ui-system/icons/arrows/chevron-left/outline.svg";

import { cn } from "@/lib/utils";

import { CategoryItem } from "./mobile-category-item";
import type { Panel } from "./mobile-panels";

type Props = {
  panel: Panel;
  isActive: boolean;
  isPast: boolean;
  onGoBack: () => void;
  onDrillDown: (index: number) => void;
  ref: Ref<HTMLDivElement>;
};

export function MobileSubPanel({
  panel,
  isActive,
  isPast,
  onGoBack,
  onDrillDown,
  ref,
}: Props) {
  return (
    <div
      ref={ref}
      // tabindex -1 allows js to call focus() on the element without allowing the user to focus it
      // furthermore, outline-none prevents the default browser focus outline
      // this keeps the focus-trap from loosing focus when going back to the parent panel
      tabIndex={-1} // do not remove this, read above
      className={cn(
        "absolute inset-0 bg-background px-5 pt-6 transition-all duration-200 ease-out outline-none translate-x-full",
        isActive && "translate-x-0",
        isPast && "-translate-x-1/4 opacity-0",
      )}
      inert={!isActive || undefined}
    >
      <button
        onClick={onGoBack}
        className="flex items-center gap-2 mb-4"
      >
        <ChevronLeftIcon className="size-5" />
        <span className="font-semibold">{panel.name}</span>
      </button>
      <ul className="ps-7">
        {panel.items.map((item, index) => (
          <li
            key={item.name}
            className="border-b border-border-grayscale-default last:border-b-0"
          >
            <CategoryItem
              item={item}
              className="py-3"
              onDrillDown={() => onDrillDown(index)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
